import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=50ef254e&scoped=true"
import script from "./commodity.vue?vue&type=script&lang=js"
export * from "./commodity.vue?vue&type=script&lang=js"
import style0 from "./commodity.vue?vue&type=style&index=0&id=50ef254e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef254e",
  null
  
)

export default component.exports